import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import idLocale from 'element-ui/lib/locale/lang/id'
Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  console.log('locales', locales)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      if (locale === 'en') {
        messages[locale] = Object.assign(locales(key), enLocale)
      }
      if (locale === 'zh-cn') {
        messages[locale] = Object.assign(locales(key), zhLocale)
      }
      if (locale === 'id') {
        messages[locale] = Object.assign(locales(key), idLocale)
      }
    }
  })
  return messages
}

const i18n = new VueI18n({
  locale: 'zh-cn',
  fallbackLocale: 'en',
  messages: loadLocaleMessages()
})

export default i18n
